/**
 * AiSession behavior — this node's `src` is an AI conversation
 *
 * Inert, like {@link Provenance}: nothing renders from it and no runtime reads
 * it. It exists so an editor can find its conversations by type in the editor
 * document (CONTENT_MODEL_SPEC §2.9, §2.10). The conversation is the node's
 * `src` file, never behavior data, so it travels by `files[k]` like any other
 * file.
 */

import { TraceBehavior } from "./tracebehavior";
import type { AiSessionData } from "../scenedata/behaviors/aisessiondata";

export class AiSession extends TraceBehavior<AiSessionData> {
    static readonly behaviorType = "AiSession" as const;
}
